import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ParentTask, TaskStatus } from 'common/types';

import { RootState } from './index';

export type ListStatus = TaskStatus;

export type CurTask = {
  name: string;
  id: string;
};

export type CurRole = {
  isAdmin: boolean;
  isInternalContacts: boolean;
  isExternalContacts: boolean;
};
interface InitialStateProp {
  taskList: ParentTask[];
  currentPage: number;
  listStatus: ListStatus;
  loading: boolean;
  tasksNum: any;
  curTotal: number;
  curTask: CurTask;
  curRole: CurRole; // 任务级别角色
  isAddVersionShow: boolean;
  curTaskId: number | undefined;
  isPublishTaskDrawerShow: boolean;
}
const initialState: InitialStateProp = {
  loading: true,
  currentPage: 1,
  listStatus: TaskStatus.AllStatus,
  tasksNum: {},
  curTotal: 0,
  taskList: [],
  curTask: {
    name: '',
    id: '',
  },
  curRole: {
    isAdmin: false, // mmvp单角色,无平台级别管理员
    isInternalContacts: false,
    isExternalContacts: false,
  },
  isAddVersionShow: false,
  curTaskId: undefined,
  isPublishTaskDrawerShow: false,
};

const task = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setLoading(state, { payload }: PayloadAction<boolean>) {
      state.loading = payload;
    },
    setTaskList(state, { payload }: PayloadAction<ParentTask[]>) {
      state.taskList = [...payload];
    },
    setCurrentPage(state, { payload }: PayloadAction<number>) {
      state.currentPage = payload;
    },
    setCurTask(state, { payload }: PayloadAction<CurTask>) {
      state.curTask = payload;
    },
    setCurRole(state, { payload }: PayloadAction<CurRole>) {
      state.curRole = payload;
    },
    setCurrentTotal(state, { payload }: PayloadAction<number>) {
      state.curTotal = payload;
    },
    setListStatus(state, { payload }: PayloadAction<ListStatus>) {
      state.listStatus = payload;
    },
    setTasksNum(state, { payload }: PayloadAction<any>) {
      state.tasksNum = payload;
    },
    setIsAddVersionShow(state, { payload }: PayloadAction<boolean>) {
      state.isAddVersionShow = payload;
    },
    setCurTaskId(state, { payload }: PayloadAction<number | undefined>) {
      state.curTaskId = payload;
    },
    setIsPublishTaskDrawerShow(state, { payload }: PayloadAction<boolean>) {
      state.isPublishTaskDrawerShow = payload;
    },
  },
});

export const {
  setLoading,
  setTaskList,
  setCurrentPage,
  setListStatus,
  setTasksNum,
  setCurrentTotal,
  setCurTask,
  setCurRole,
  setIsAddVersionShow,
  setCurTaskId,
  setIsPublishTaskDrawerShow,
} = task.actions;
export const selectTaskList = (state: RootState) => state.task.taskList;
export const selectIsAddVersionShow = (state: RootState) => state.task.isAddVersionShow;
export const selectCurTaskId = (state: RootState) => state.task.curTaskId;
export const selectIsPublishTaskDrawerShow = (state: RootState) => state.task.isPublishTaskDrawerShow;

export default task.reducer;
